import { useCallback, useEffect, useRef, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { leadsService } from '../services/leads.service';

const POLL_MS = 60_000;
export const LEADS_FOLLOWED_EVENT = 'leads:followed';

export function useUnfollowedLeadsCount(): {
  unfollowedCount: number;
} {
  const { user } = useAuth();
  const [unfollowedCount, setUnfollowedCount] = useState(0);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const isEligible =
    !!user &&
    (user.role === 'ADMIN' || user.department?.toLowerCase() === 'sales');

  const refresh = useCallback(() => {
    if (!isEligible) return;
    leadsService.getUnfollowedCount().then(setUnfollowedCount).catch(() => {});
  }, [isEligible]);

  useEffect(() => {
    if (!isEligible) {
      setUnfollowedCount(0);
      return;
    }

    refresh();
    timerRef.current = setInterval(refresh, POLL_MS);

    const onFollowed = () => refresh();
    window.addEventListener(LEADS_FOLLOWED_EVENT, onFollowed);

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
      window.removeEventListener(LEADS_FOLLOWED_EVENT, onFollowed);
    };
  }, [isEligible, refresh]);

  return { unfollowedCount };
}
